import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { styled } from '@mui/material'

import type { Button as ButtonProps } from '../../types/app';

const themeClassMap = {
    default: 'border-violet-800 bg-violet-800 text-white hover:bg-violet-600 hover:border-violet-600',
    outline: 'border-black bg-transparent text-black hover:text-gray-500 hover:border-gray-500'
};

const Link = styled(GatsbyLink)(({theme}) => ({
    "&:hover" : {
        backgroundColor : theme.palette.primary.main,
        color : 'black!important'
    }
}))

export const Button = (props: ButtonProps) => (
    <Link
        to                  = {props.url}
        className           = {`py-3 px-8 inline-block border rounded-md transition-all duration-300 ${themeClassMap[props.theme] ?? themeClassMap['default']}`}
        data-sb-object-id   = {props.contentful_id}
        data-sb-field-path  = "label"
    >
        {props.label}
    </Link>
);

/*
const variantMap = {
    default     : 'text',
    outline     : 'outlined',
    contained   : 'contained'
};

export const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
    return (
        <ButtonMUI
            variant             = {variantMap[props.theme ?? 'default'] || variantMap['default']}
            component           = {Link}
            to                  = {props.url}
            {...props}
            data-sb-object-id   = {props.contentful_id}
            data-sb-field-path  = "label"
        >
            {props.label}
        </ButtonMUI>
    );
};
*/

export default Button;
